import "CompLib/boilerplates/navi-bootstrap-standard";
import { NavFullscreen } from "CompLibTheme/boilerplates/nav-fullscreen";
import { NavFullScreenService } from "CompLibTheme/services/nav-fullscreen-service";
import "./styles.scss";

class NavTeslaFullScreen {
  constructor({ smoothScroll = undefined } = {}) {
    this.navFullScreenService = new NavFullScreenService({ smoothScroll });
    this.navFullScreen = new NavFullscreen();
  }
}

export { NavTeslaFullScreen };
